export const renos = [
	{
		name: "Kitchens",
		rows: [
			// {
			// 	brand: "",
			// 	process: "",
			// 	info: "",
			// 	available: {
			// 		silver: true,
			// 		limited_silver: false,
			// 		gold: true,
			// 		platinum: true
			// 	},
			// 	partner: ""
			// },
			{
				brand: "Kitchen Contours",
				process: "<p>If you already have a kitchen design send your plans onto <a href='mailto:simon@cherrytree.co.nz' target='_blank'>Simon</a> for pricing.  We will organise for cabinet samples to be sent out to you.</p>",
				info: "<p>For the supply and installation of cabinetry. High-end kitchens with savings of around 20%. <strong>Kitchens can be supplied nationwide.</strong></p>",
				available: {
					silver: false,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: ""
			},
			{
				brand: "Ali Withers Kitchen Design",
				process: "<p>If you require a kitchen designer, you can contact Kitchen Contours designer and Cherrytree MemberBiz partner <a href='http://www.aliwitherskitchens.biz/' target='_blank'>Ali Withers</a> </p>",
				info: "<p>Ali can work remotely with those not based in Wellington.</p>",
				available: {
					silver: true,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: ""
			},
			{
				brand: "Supremo Kitchens",
				process: "<p>From budget to bling Supremo kitchens offers a 10% discount to Cherrytree members.  Members work directly with Supremo Kitchens.  Contact Phil on:</p><p>Mobile: <a href='tel:021663154'>021 663 154</a></p><p>Email: <a href='mailto:info@supremokitchens.co.nz' target='_blank'>info@supremokitchens.co.nz</a> </p><p>Address: Unit 6 / 155 Gracefield Road, Seaview</p>",
				info: "<p>A good option if you want to have minimal involvement.  Phil will do all the work for you.</p><p>Wellington region only</p>",
				available: {
					silver: true,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: "memberbiz"
			},
			{
				brand: "PlaceMakers",
				process: "<p>Deal directly with PlaceMakers, quote your membership number to get a 10% discount. </p>",
				info: "<p>Nationwide</p>",
				available: {
					silver: true,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: ""
			},
		],
	},
	{
		name: "Bathrooms",
		rows: [
			{
				brand: "<p>We have over 50 bathroom brands available to source all your bathroom requirements.  Some of our higher end brands include brands such as Plumbline, St  Michel, Athena, Englefield and Clearlite and mid-end brands like NewTech and Bathroom Direct. </p>",
				process: "<p>Silver members can access some bathroom ware items – see that items listed on our website.</p><p>Other bathroom ware is exclusive to Gold and Platinum members. If the item you would like is not listed on our website then <a href='mailto:quotes@cherrytree.co.nz' target='_blank'>email us for a quote.</a></p>",
				info: "<p>For a full list of bathroom brands search our <a href='../brands'>brands list</a></p><p>Many of the high-end brands offer made for you vanities where you choose the colour, size handles plus custom benchtops sizes.</p>",
				available: {
					silver: true,
					limited_silver: true,
					gold: true,
					platinum: true
				},
				partner: ""
			},
			{
				brand: "PlaceMakers",
				process: "<p>Deal directly with PlaceMakers.  Variable discount available when you quote your Cherrytree membership number.</p>",
				info: "<p>Nationwide</p>",
				available: {
					silver: true,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: "discount"
			},
		],
	},
	{
		name: "Benchtops",
		rows: [
			{
				brand: "<p>We have various benchtop wholesale partners</p><p>Granite/Caesarstone/Silestone <br />(Auckland Wellington, Christchurch)</p><p>Laminate and Corian benchtops<br/>(Wellington only)</p>",
				process: "<p>Request your samples from Cherrytree or visit your local showroom</p><p>Once you have decided on your benchtop e-mail detail to: <a href='mailto:quotes@cherrytree.co.nz' target='_blank'>quotes@cherrytree.co.nz</a></p>",
				info: "<p>Christchurch: <br/>BENCHTOP CONCEPTS<br/>398 Halswell Junction Road<br/>Halswell<br/>Christchurch<br/><a href='tel:033429218>03 342 9218</a></p><p>Wgtn: TBC</p><p>Auckland: TBC</p>",
				available: {
					silver: false,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: ""
			},
		],
	},
	{
		name: "Splashbacks and Mirrors",
		rows: [
			{
				brand: "<p>Painted glass splashbacks (any Resene colour)/digital image splashbacks/custom shaped splashbacks/kitchen island fronts/toughened mirror splashbacks and made to measure mirrors for all areas of the home. </p>",
				process: "<p>Standard and custom sizes available. <a href='mailto:quotes@cherrytree.co.nz' target='_blank'>E-mail Cherrytree</a> with size and a description of what you would like. </p>",
				info: "<p>We can supply only or supply and install in Auckland, Wellington, Christchurch.</p><p>Supply only for the rest of New Zealand</p>",
				available: {
					silver: false,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: ""
			},
		],
	},
	{
		name: "Tiles",
		rows: [
			{
				brand: "<a href='https://tiletrends.co.nz/' target='_blank'>Tile Trends</a>",
				process: "<p>Choose your tiles then email Cherrytree for a price.</p>",
				info: "<p>Tile TrendsShowrooms are in:<br/>Auckland<br/>Wellington<br/>Tauranga<br/>Palmerston North<br/>Paraparaumu</p>",
				available: {
					silver: false,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: "wholesale"
			},{
				brand: "<a href='https://designa.co.nz/home' target='_blank'>Designa Tiles</a>",
				process: "<p>Visit the website or drop into the showroom if you are in Auckland.  Choose tiles then send information through to <a href='mailto:quotes@cherrytree.co.nz' target='_blank'>Cherrytree for a quote.</a></p><p>f you are not in Auckland and would like a sample, you can request these by contacting Designa Tiles at <a href='mailto:info@designa.co.nz' target='_blank'>info@designa.co.nz</a></p>",
				info: "",
				available: {
					silver: false,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: "wholesale"
			},
			{
				brand: "<a href='https://www.tilemax.co.nz/home' target='_blank'>Tile Max</a>",
				process: "<p>Members deal directly with Tile Max.  Quote your membership number to get a 25% discount</p>",
				info: "<p>Tile Max have a great visualiser tool to help you pick the perfect tiles for your home.</p>",
				available: {
					silver: true,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: "discount"
			},
		],
	},
	{
		name: "Carpet",
		rows: [
			{
				brand: "Feltex, Godfrey Hirst, Belgotex, Irvine",
				process: "<p>Find a local installer and get a measure and quote for laying. </p><p>Choose your carpet and get a price from Cherrytree. </p><p>Cherrytree will get the Carpet delivered directly to your layer or to site.</p>",
				info: "",
				available: {
					silver: false,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: ""
			},
		],
	},
	{
		name: "Heating",
		rows: [
			{
				brand: "ESCEA Fires",
				process: "<p>Select your fireplace and send details through to for a quote at <a href='mailto:quotes@cherrytree.co.nz' target='_blank'>quotes@cherrytree.co.nz</a> </p>",
				info: "",
				available: {
					silver: false,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: "wholesale"
			},
			{
				brand: "Heatpumps",
				process: "<p>See the Cherrytree website</p>",
				info: "",
				available: {
					silver: true,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: ""
			},
			{
				brand: "Rinnai",
				process: "<p>See the Cherrytree website  or email <a href='mailto:quotes@cherrytree.co.nz' target='_blank'>quotes@cherrytree.co.nz</a></p>",
				info: "",
				available: {
					silver: true,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: ""
			},
		],
	},
	{
		name: "Flooring",
		rows: [
			{
				brand: "<a href='https://www.projectfloors.co.nz/' target='_blank'>Project Floors</a>",
				process: "<p>Order your free samples directly off Project Floors website. Or visit the Cherrytree showroom if you are in Wellington</p><p>Once you have chosen your flooring, <a href='mailto:quotes@cherrytree.co.nz' target='_blank'>email Cherrytree for a price.</a></p><p>Source an installer from Memberbiz or other</p>",
				info: "<p>Supplier of Laminate and vinyl planks</p>",
				available: {
					silver: false,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: "wholesale"
			},
			{
				brand: "<a href='https://www.plantationbamboo.co.nz/' target='_blank'>Plantation Bamboo </a>",
				process: "<p>Order your samples through their website.</p><p>Choose your product and contact <a href='mailto:quotes@cherrytree.co.nz' target='_blank'>Cherrytree for a quote.</a></p><p>Source an installer from Memberbiz or other</p>",
				info: "<p>Plantation Bamboo supply bamboo flooring and also have some great decking and panel products.</p>",
				available: {
					silver: false,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: ""
			},
			{
				brand: "<a href='https://www.floorwise.co.nz/' target='_blank'>Floorwise</a>",
				process: "<p>Request a price directly off Floorwise and quote your Cherrytree membership number.</p>",
				info: "<p>Floorwise is a supplier of Polyfloor, Laminate, Planking and Vinyl </p><p>Discounts are an additional 5% off already reduced prices.</p>",
				available: {
					silver: true,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: ""
			},
		],
	},
	{
		name: "Lighting",
		rows: [
			{
				brand: "<a href='https://superlux.co.nz/' target='_blank'>Superlux</a>",
				process: "<p>Browse the Superlux website and <a href='mailto:quotes@cherrytree.co.nz' target='_blank'>request a price from Cherrytree.</a></p>",
				info: "<p>For all types of home lighting options</p><p><a href='https://superlux.co.nz/' target='_blank'>https://superlux.co.nz/</a></p>",
				available: {
					silver: false,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: "wholesale"
			},
			{
				brand: "<a href='http://www.spartanled.co.nz/' target='_blank'>Spartan Lighting</a>",
				process: "<p>Browse the website and <a href='mailto:quotes@cherrytree.co.nz' target='_blank'>request a price from Cherrytree.</a></p>",
				info: "<p>For LED lighting and fittings</p><p><a href='http://www.spartanled.co.nz/' target='_blank'>http://www.spartanled.co.nz/</a></p>",
				available: {
					silver: false,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: "wholesale"
			},
			{
				brand: "<a href='https://www.mrralph.co.nz/' target='_blank'>Mr Ralph</a>",
				process: "<p>Request a price from Mr Ralph.  Quote your membership number.</p>",
				info: "<p>For beautiful designer lighting </p><p><a href='https://www.mrralph.co.nz/' target='_blank'>https://www.mrralph.co.nz/</a></p>",
				available: {
					silver: true,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: "discount"
			},
		],
	},
	{
		name: "Curtains and Fabric",
		rows: [
			{
				brand: "<p>Warwick (36% off RRP)</p><p>Maurice Kain (47% off RRP)</p><p>Resene Fabrics (47% off RRP)</p>",
				process: "<p>Pick your fabric then e-mail <a href='mailto:quotes@cherrytree.co.nz' target='_blank'>Cherrytree for a quote.</a> </p>",
				info: "<p>See Wellington MemberBiz listing for local curtain makers.</p><p>For curtain makers in Auckland and Hamilton <a href='mailto:quotes@cherrytree.co.nz' target='_blank'>contact Cherrytree</a>.</p>",
				available: {
					silver: false,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: ""
			},
		],
	},
	{
		name: "Blinds",
		rows: [
			{
				brand: "<a href='https://www.weathermaster.co.nz/' target='_blank'>Weathermaster blinds</a>",
				process: "<p>Get samples directly from Weathermaster website.</p><p>Pick your blinds then contact <a href='mailto:quotes@cherrytree.co.nz' target='_blank'>Cherrytree to organise a measure and quote.</a> </p>",
				info: "",
				available: {
					silver: false,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: "wholesale"
			},
			{
				brand: "<a href='https://www.conceptblindsandshutters.co.nz/' target='_blank'>Concept Blinds and Shutters</a>",
				process: "<p>Deal directly with Concept Blinds and quote your Cherrytree membership number.</p>",
				info: "<p>Wellington based members</p>",
				available: {
					silver: true,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: "discount"
			},
			{
				brand: "<a href='https://www.weathermaster.co.nz/' target='_blank'>Weathermaster</a>",
				process: "<p><a href='mailto:memberservices@cherrytree.co.nz' target='_blank'>Contact Cherrytree</a> to arrange for a Weathermaster rep to come visit you on site.</p><p>Cherrytree will then provide you will a quote.</p>",
				info: "<p>For Outdoor Blinds and Awnings</p>",
				available: {
					silver: false,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: ""
			},
		],
	},
	{
		name: "Door Hardware",
		rows: [
			{
				brand: "<a href='https://www.sopersmac.co.nz/' target='_blank'>Sopersmac</a>",
				process: "<p>Choose your hardware from the Sopersmac website then contact <a href='mailto:quotes@cherrytree.co.nz' target='_blank'>Cherrytree for a quote.</a> </p>",
				info: "<p>Members also get access to all other Sopersmac products.</p>",
				available: {
					silver: false,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: "wholesale"
			},
		],
	},
	{
		name: "Wardrobe Fit Outs",
		rows: [
			{
				brand: "ELFA",
				process: "<p>Use the ELFA design software, save it with your name & we will quote it for you. Email <a href='mailto:quotes@cherrytree.co.nz' target='_blank'>quotes@cherrytree.co.nz</a> once the plan is complete. 30% of RRP.</p>",
				info: "<p><a href='https://epo.elfa.com/login' target='_blank'>ELFA Tools</a></p><p>User ID: simon@cherrytree.co.nz</p><p>Password: WgtnOrders#1</p>",
				available: {
					silver: false,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: "wholesale"
			},
			{
				brand: "<a href='https://www.regencywardrobes.co.nz/' target='_blank'>Regency Wardrobes</a>",
				process: "<p>Sketch out a plan for your Regency Wardrobe & email it to us to get it priced for supply & installation. </p>",
				info: "<p>Nationwide</p>",
				available: {
					silver: false,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: "wholesale"
			},
		],
	},
	{
		name: "Paint",
		rows: [
			{
				brand: "Resene",
				process: "<p>Deal directly with Resene.  Show your Cherrytree membership number.</p>",
				info: "<ul><li><strong>30% discount</strong> on Resene premium paints 4 litres and below</li><li><strong>20% discount</strong> the full retail price of decorating accessories</li><li><strong>10% discount</strong> the full retail price of Resene premium paint 10 litre pails</li><li><strong>25% discount</strong> the full retail price of wallpaper. This discount does not apply to specials or sale items, and is not applicable during annual Resene sales. </li></ul>",
				available: {
					silver: true,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: ""
			},
		],
	},
	{
		name: "Wallpaper",
		rows: [
			{
				brand: "<a href='https://aspiringwalls.co.nz/' target='_blank'>Aspiring Walls</a>",
				process: "<p>Order samples directly off their website. </p><p>Choose your wallpaper and contact <a href='mailto:quotes@cherrytree.co.nz' target='_blank'>Cherrytree for a quote.</a> </p>",
				info: "<p><a href='https://aspiringwalls.co.nz/' target='_blank'>https://aspiringwalls.co.nz/</a></p>",
				available: {
					silver: false,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: ""
			},
		],
	},
	{
		name: "Building and Landscaping Supplies",
		rows: [
			{
				brand: "PlaceMakers",
				process: "<p>Quote your Cherrytree membership in store. Discounts will vary depending on product.</p>",
				info: "",
				available: {
					silver: false,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: ""
			},
		],
	},
	{
		name: "Outdoor Fires",
		rows: [
			{
				brand: "<a href='https://www.infernofires.co.nz/' target='_blank'>Inferno Fires</a>",
				process: "<p>Deal directly with Inferno Fires, quote your membership number to get a 20% discount. </p>",
				info: "",
				available: {
					silver: false,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: ""
			},
		],
	},
	{
		name: "Home Furnishings and Whiteware",
		rows: [
			{
				brand: "<p>We have a huge range of furniture and design brands to help complete your home renovation or build:</p><ul><li>Whiteware</li><li>Furniture</li><li>Beds and Bedding</li><li>TV&apos;s</li><li>Kitchenware and appliances </li><li>Soft furnishings</li><li>Outdoor furniture and supplies</li></ul>",
				process: "<p>Find the products you want to buy then come to Cherrytree for a quote. </p><p>Search our products and brands on our website.</p><p>Remember we have over 550,000 products from more than 2,400 brands so we cannot list everything on our website.  If you are unsure if we stock a certain product or brand simply contact us. <a href='mailto:quotes@cherrytree.co.nz' target='_blank'>quotes@cherrytree.co.nz</a> </p><p>If we do not stock a certain item the chances are we will be able to find a similar product for you.</p>",
				info: "<p>Silver members save up to 25% off RRP</p><p>Gold members save up to 60% off RRP</p><p>Platinum members save up to 65% off RRP</p><p>Savings vary from product to product.</p>",
				available: {
					silver: true,
					limited_silver: false,
					gold: true,
					platinum: true
				},
				partner: ""
			},
		],
	},
]